import Footer from "components/Footer/Footer";
import Header from "components/Header/Header";
import { MainContainer } from "components/MainContainer/MainContainer";

function AppMain() {
  return (
    <>
      <Header />
      <MainContainer />
      <Footer />
    </>
  );
}

export default AppMain;
